import { RelationType } from './relation.types.js';
export const RELATION_TYPE_DEFINITIONS = [
    // Infrastructure and Hosting
    {
        type: RelationType.RUNS_ON,
        from: [
            'application',
            'service',
            'container',
            'function',
            'api',
            'saas',
            'cache',
            'queue',
            'message_broker',
            'database',
            'gitops',
            'cicd_pipeline',
            'monitoring_service',
            'logging_service',
            'backup_service',
            'integration_platform',
        ],
        to: [
            'server',
            'virtual_machine',
            'platform',
            'container',
            'container_orchestrator',
            'cloud_platform',
            'cluster',
        ],
        description: 'Component runs on infrastructure',
    },
    {
        type: RelationType.DEPENDS_ON,
        from: [
            'application',
            'service',
            'api',
            'function',
            'container',
            'cicd_pipeline',
            'gitops',
            'saas',
            'integration_platform',
            'monitoring_service',
            'logging_service',
            'backup_service',
            'other',
        ],
        to: [
            'application',
            'service',
            'saas',
            'database',
            'cache',
            'queue',
            'message_broker',
            'platform',
            'cloud_platform',
            'identity_provider',
            'container_registry',
            'dns',
            'secret_manager',
            'network',
            'storage',
            'data_lake',
            'monitoring_service',
            'logging_service',
            'gitops',
        ],
        description: 'Component depends on another component',
    },
    {
        type: RelationType.HOSTED_BY,
        from: [
            'application',
            'database',
            'service',
            'container',
            'api',
            'function',
            'cache',
            'queue',
            'message_broker',
            'gitops',
            'cicd_pipeline',
            'monitoring_service',
            'logging_service',
        ],
        to: [
            'server',
            'virtual_machine',
            'platform',
            'container',
            'container_orchestrator',
            'cloud_platform',
            'cluster',
            'saas',
        ],
        description: 'Component is hosted by infrastructure',
    },
    // Data and Storage
    {
        type: RelationType.READS_FROM,
        from: [
            'application',
            'service',
            'api',
            'function',
            'integration_platform',
            'cicd_pipeline',
            'gitops',
            'monitoring_service',
            'backup_service',
            'other',
        ],
        to: [
            'database',
            'storage',
            'cache',
            'queue',
            'data_lake',
            'message_broker',
            'secret_manager',
        ],
        description: 'Component reads data from storage',
    },
    {
        type: RelationType.WRITES_TO,
        from: [
            'application',
            'service',
            'api',
            'function',
            'integration_platform',
            'cicd_pipeline',
            'monitoring_service',
            'logging_service',
            'backup_service',
            'other',
        ],
        to: [
            'database',
            'storage',
            'queue',
            'data_lake',
            'message_broker',
            'cache',
        ],
        description: 'Component writes data to storage',
    },
    {
        type: RelationType.STORES_DATA_IN,
        from: [
            'application',
            'service',
            'function',
            'api',
            'saas',
            'container',
            'integration_platform',
            'cicd_pipeline',
            'gitops',
            'monitoring_service',
            'logging_service',
            'backup_service',
        ],
        to: ['database', 'storage', 'data_lake', 'cache'],
        description: 'Component stores data in storage system',
    },
    {
        type: RelationType.BACKED_UP_BY,
        from: [
            'database',
            'storage',
            'data_lake',
            'application',
            'service',
            'server',
            'virtual_machine',
            'container_orchestrator',
            'container_registry',
            'secret_manager',
            'identity_provider',
            'cluster',
            'platform',
            'cloud_platform',
            'saas',
        ],
        to: ['storage', 'backup_service', 'cloud_platform'],
        description: 'Data is backed up by backup system',
    },
    {
        type: RelationType.REPLICATES_TO,
        from: ['database', 'storage', 'data_lake', 'cache'],
        to: ['database', 'storage', 'data_lake', 'cache'],
        description: 'Data replicates to another storage',
    },
    // Network and Security
    {
        type: RelationType.IN_ZONE,
        from: [
            'application',
            'server',
            'virtual_machine',
            'database',
            'network',
            'service',
            'container',
            'container_orchestrator',
            'container_registry',
            'api',
            'function',
            'cloud_platform',
            'security_zone',
            'zone',
            'firewall',
            'load_balancer',
            'gateway',
            'storage',
            'platform',
            'cluster',
            'cache',
            'queue',
            'message_broker',
            'data_lake',
            'saas',
            'cdn',
            'proxy',
            'vpn',
            'dns',
            'identity_provider',
            'secret_manager',
            'monitoring_service',
            'logging_service',
            'backup_service',
            'integration_platform',
            'cicd_pipeline',
            'gitops',
            'other',
        ],
        to: ['zone', 'cloud_platform'],
        description: 'Component is in a logical zone (Azure, DMZ, On-prem, etc.)',
    },
    {
        type: RelationType.IN_SECURITY_ZONE,
        from: [
            'application',
            'server',
            'virtual_machine',
            'database',
            'network',
            'service',
            'container',
            'container_orchestrator',
            'container_registry',
            'api',
            'function',
            'zone',
            'firewall',
            'load_balancer',
            'gateway',
            'storage',
            'platform',
            'cloud_platform',
            'cluster',
            'cache',
            'queue',
            'message_broker',
            'data_lake',
            'saas',
            'cdn',
            'proxy',
            'vpn',
            'dns',
            'identity_provider',
            'secret_manager',
            'monitoring_service',
            'logging_service',
            'backup_service',
            'integration_platform',
            'cicd_pipeline',
            'gitops',
            'other',
        ],
        to: ['security_zone'],
        description: 'Component is in a security zone with restricted access (Sone 1-5)',
    },
    {
        type: RelationType.USES_NETWORK,
        from: [
            'application',
            'server',
            'virtual_machine',
            'service',
            'database',
            'container',
            'container_orchestrator',
            'container_registry',
            'cloud_platform',
            'cluster',
            'cache',
            'queue',
            'message_broker',
            'saas',
            'api',
            'function',
            'firewall',
            'load_balancer',
            'gateway',
            'proxy',
            'cdn',
            'dns',
            'identity_provider',
            'secret_manager',
            'storage',
            'data_lake',
            'monitoring_service',
            'logging_service',
            'backup_service',
            'integration_platform',
            'cicd_pipeline',
            'gitops',
            'other',
        ],
        to: ['network', 'vpn'],
        description: 'Component uses network',
    },
    {
        type: RelationType.CONNECTS_TO,
        from: [
            'application',
            'service',
            'api',
            'container',
            'cloud_platform',
            'zone',
            'network',
            'gateway',
            'vpn',
            'proxy',
            'load_balancer',
            'cdn',
            'saas',
            'integration_platform',
            'cicd_pipeline',
            'gitops',
            'function',
            'other',
        ],
        to: [
            'application',
            'service',
            'api',
            'database',
            'network',
            'cloud_platform',
            'zone',
            'gateway',
            'message_broker',
            'cache',
            'queue',
            'saas',
            'identity_provider',
            'storage',
            'data_lake',
            'container_registry',
            'container_orchestrator',
            'vpn',
            'proxy',
            'load_balancer',
        ],
        description: 'Component connects to another component',
    },
    {
        type: RelationType.PROTECTED_BY,
        from: [
            'application',
            'server',
            'virtual_machine',
            'database',
            'network',
            'cloud_platform',
            'api',
            'zone',
            'container_orchestrator',
            'container_registry',
            'cluster',
            'service',
            'saas',
            'storage',
            'data_lake',
            'cache',
            'queue',
            'message_broker',
            'identity_provider',
            'secret_manager',
            'container',
            'function',
            'platform',
            'cicd_pipeline',
            'gitops',
            'monitoring_service',
            'logging_service',
            'backup_service',
            'integration_platform',
            'other',
        ],
        to: ['firewall', 'load_balancer', 'cdn', 'proxy', 'gateway', 'vpn'],
        description: 'Component is protected by security device',
    },
    {
        type: RelationType.ISOLATED_FROM,
        from: [
            'application',
            'zone',
            'security_zone',
            'cloud_platform',
            'network',
            'database',
            'service',
            'container',
            'other',
        ],
        to: [
            'application',
            'zone',
            'network',
            'security_zone',
            'service',
            'database',
        ],
        description: 'Component is isolated from another',
    },
    {
        type: RelationType.EXPOSES_SERVICE,
        from: [
            'application',
            'api',
            'service',
            'cloud_platform',
            'gateway',
            'load_balancer',
            'cdn',
            'proxy',
            'saas',
            'other',
        ],
        to: ['network', 'zone', 'security_zone'],
        description: 'Component exposes service to network',
    },
    // Service relationships
    {
        type: RelationType.PROVIDES_SERVICE,
        from: [
            'application',
            'platform',
            'api',
            'cloud_platform',
            'container_orchestrator',
            'container_registry',
            'saas',
            'gateway',
            'load_balancer',
            'cdn',
            'dns',
            'identity_provider',
            'secret_manager',
            'monitoring_service',
            'logging_service',
            'backup_service',
            'integration_platform',
            'gitops',
        ],
        to: ['service'],
        description: 'Component provides a service',
    },
    {
        type: RelationType.CONSUMED_BY,
        from: [
            'service',
            'api',
            'message_broker',
            'saas',
            'cache',
            'queue',
            'database',
            'storage',
            'identity_provider',
            'secret_manager',
            'dns',
            'cdn',
            'monitoring_service',
            'logging_service',
        ],
        to: [
            'application',
            'service',
            'cloud_platform',
            'api',
            'function',
            'integration_platform',
            'cicd_pipeline',
            'gitops',
            'container',
            'container_orchestrator',
            'other',
        ],
        description: 'Service is consumed by component',
    },
    {
        type: RelationType.PART_OF_SERVICE,
        from: [
            'application',
            'api',
            'function',
            'container',
            'database',
            'cache',
            'queue',
            'message_broker',
            'other',
        ],
        to: ['service'],
        description: 'Component is part of service',
    },
    // Platform Relationships
    {
        type: RelationType.PART_OF_PLATFORM,
        from: [
            'application',
            'service',
            'container',
            'api',
            'container_registry',
            'database',
            'cache',
            'queue',
            'message_broker',
            'monitoring_service',
            'logging_service',
            'secret_manager',
            'identity_provider',
            'function',
            'cicd_pipeline',
            'gitops',
            'other',
        ],
        to: ['platform', 'cloud_platform', 'container_orchestrator', 'saas'],
        description: 'Component is part of platform',
    },
    {
        type: RelationType.USES_PLATFORM,
        from: [
            'application',
            'service',
            'container',
            'api',
            'cicd_pipeline',
            'gitops',
            'function',
            'database',
            'cache',
            'monitoring_service',
            'logging_service',
            'backup_service',
            'other',
        ],
        to: [
            'platform',
            'cloud_platform',
            'integration_platform',
            'container_orchestrator',
            'saas',
        ],
        description: 'Component uses platform',
    },
    {
        type: RelationType.DEPLOYED_ON,
        from: [
            'application',
            'container',
            'function',
            'api',
            'service',
            'database',
            'cache',
            'queue',
            'message_broker',
            'cicd_pipeline',
            'gitops',
            'monitoring_service',
            'logging_service',
            'backup_service',
            'integration_platform',
            'other',
        ],
        to: [
            'platform',
            'server',
            'virtual_machine',
            'cloud_platform',
            'container_orchestrator',
            'cluster',
        ],
        description: 'Component is deployed on infrastructure',
    },
    // Monitoring and Operations
    {
        type: RelationType.LOGS_TO,
        from: [
            'application',
            'server',
            'virtual_machine',
            'service',
            'database',
            'container',
            'api',
            'container_orchestrator',
            'container_registry',
            'function',
            'gateway',
            'load_balancer',
            'firewall',
            'proxy',
            'cdn',
            'vpn',
            'dns',
            'identity_provider',
            'secret_manager',
            'cache',
            'queue',
            'message_broker',
            'storage',
            'data_lake',
            'saas',
            'cicd_pipeline',
            'gitops',
            'integration_platform',
            'backup_service',
            'monitoring_service',
            'cluster',
            'platform',
            'cloud_platform',
            'other',
        ],
        to: ['logging_service', 'storage', 'data_lake', 'cloud_platform'],
        description: 'Component logs to logging service',
    },
    {
        type: RelationType.MONITORED_BY,
        from: [
            'application',
            'server',
            'virtual_machine',
            'service',
            'database',
            'network',
            'container',
            'cloud_platform',
            'container_orchestrator',
            'container_registry',
            'cluster',
            'gateway',
            'api',
            'function',
            'load_balancer',
            'firewall',
            'proxy',
            'cdn',
            'vpn',
            'dns',
            'identity_provider',
            'secret_manager',
            'cache',
            'queue',
            'message_broker',
            'storage',
            'data_lake',
            'saas',
            'platform',
            'cicd_pipeline',
            'gitops',
            'integration_platform',
            'backup_service',
            'logging_service',
            'other',
        ],
        to: ['monitoring_service', 'cloud_platform', 'saas'],
        description: 'Component is monitored by monitoring service',
    },
    {
        type: RelationType.ALERTS_TO,
        from: ['monitoring_service', 'logging_service', 'backup_service'],
        to: ['application', 'service', 'saas', 'integration_platform'],
        description: 'Monitoring alerts to notification service',
    },
    // Integration and Data Flow
    {
        type: RelationType.SENDS_DATA_TO,
        from: [
            'application',
            'service',
            'api',
            'function',
            'integration_platform',
            'cicd_pipeline',
            'gitops',
            'message_broker',
            'monitoring_service',
            'logging_service',
            'backup_service',
            'saas',
            'database',
            'cache',
            'other',
        ],
        to: [
            'application',
            'service',
            'database',
            'queue',
            'storage',
            'cloud_platform',
            'data_lake',
            'message_broker',
            'cache',
            'api',
            'saas',
            'logging_service',
            'monitoring_service',
            'integration_platform',
        ],
        description: 'Component sends data to another',
    },
    {
        type: RelationType.RECEIVES_DATA_FROM,
        from: [
            'application',
            'service',
            'api',
            'cloud_platform',
            'data_lake',
            'database',
            'cache',
            'queue',
            'message_broker',
            'integration_platform',
            'cicd_pipeline',
            'gitops',
            'monitoring_service',
            'logging_service',
            'backup_service',
            'function',
            'saas',
            'other',
        ],
        to: [
            'application',
            'service',
            'queue',
            'integration_platform',
            'message_broker',
            'api',
            'database',
            'storage',
            'data_lake',
            'cache',
            'saas',
        ],
        description: 'Component receives data from another',
    },
    {
        type: RelationType.CALLS_API,
        from: [
            'application',
            'service',
            'function',
            'cloud_platform',
            'cicd_pipeline',
            'gitops',
            'integration_platform',
            'monitoring_service',
            'logging_service',
            'backup_service',
            'saas',
            'other',
        ],
        to: ['api', 'service', 'cloud_platform', 'gateway', 'saas'],
        description: 'Component calls API',
    },
    // Authentication and Secrets
    {
        type: RelationType.USES_IDP,
        from: [
            'application',
            'service',
            'api',
            'cloud_platform',
            'container_orchestrator',
            'container_registry',
            'database',
            'storage',
            'saas',
            'function',
            'cicd_pipeline',
            'gitops',
            'gateway',
            'vpn',
            'proxy',
            'platform',
            'integration_platform',
            'monitoring_service',
            'logging_service',
            'backup_service',
            'secret_manager',
            'other',
        ],
        to: ['identity_provider', 'saas'],
        description: 'Component uses identity provider',
    },
    {
        type: RelationType.AUTHENTICATES_WITH,
        from: [
            'application',
            'service',
            'api',
            'cloud_platform',
            'container_orchestrator',
            'container_registry',
            'database',
            'storage',
            'cicd_pipeline',
            'gitops',
            'function',
            'container',
            'gateway',
            'vpn',
            'proxy',
            'platform',
            'integration_platform',
            'monitoring_service',
            'logging_service',
            'backup_service',
            'secret_manager',
            'saas',
            'other',
        ],
        to: ['identity_provider', 'service', 'saas', 'cloud_platform'],
        description: 'Component authenticates with provider',
    },
    {
        type: RelationType.USES_SECRET,
        from: [
            'application',
            'service',
            'api',
            'container',
            'cicd_pipeline',
            'gitops',
            'container_orchestrator',
            'function',
            'database',
            'storage',
            'saas',
            'integration_platform',
            'monitoring_service',
            'logging_service',
            'backup_service',
            'gateway',
            'proxy',
            'vpn',
            'other',
        ],
        to: ['secret_manager', 'cloud_platform'],
        description: 'Component uses secrets from secret manager',
    },
    // DNS
    {
        type: RelationType.RESOLVES_VIA,
        from: [
            'application',
            'service',
            'api',
            'gateway',
            'load_balancer',
            'cdn',
            'proxy',
            'vpn',
            'container',
            'function',
            'saas',
            'integration_platform',
            'cicd_pipeline',
            'gitops',
            'other',
        ],
        to: ['dns', 'cloud_platform'],
        description: 'Component resolves names via DNS',
    },
    // CI/CD
    {
        type: RelationType.DEPLOYS_TO,
        from: ['cicd_pipeline', 'gitops', 'integration_platform'],
        to: [
            'server',
            'virtual_machine',
            'container_orchestrator',
            'cloud_platform',
            'cluster',
            'platform',
        ],
        description: 'Pipeline deploys to infrastructure',
    },
    {
        type: RelationType.PULLS_FROM,
        from: [
            'container_orchestrator',
            'cicd_pipeline',
            'gitops',
            'cluster',
            'container',
            'application',
            'service',
        ],
        to: ['container_registry', 'storage'],
        description: 'Component pulls images from registry',
    },
    {
        type: RelationType.PUSHES_TO,
        from: ['cicd_pipeline', 'gitops', 'application', 'service'],
        to: ['container_registry', 'storage'],
        description: 'Pipeline pushes images to registry',
    },
];
/**
 * Get valid relation types for source and target component types
 */
export function getValidRelationTypes(fromType, toType) {
    if (!fromType && !toType) {
        return RELATION_TYPE_DEFINITIONS;
    }
    return RELATION_TYPE_DEFINITIONS.filter(def => {
        const matchesFrom = !fromType || def.from.includes(fromType);
        const matchesTo = !toType || def.to.includes(toType);
        return matchesFrom && matchesTo;
    });
}
/**
 * Check if a relation type is valid for given component types
 */
export function isValidRelationType(relationType, fromType, toType) {
    const definition = RELATION_TYPE_DEFINITIONS.find(def => def.type === relationType);
    if (!definition)
        return false;
    return definition.from.includes(fromType) && definition.to.includes(toType);
}
